module.exports = __webpack_public_path__ + "img/japanese.4f5d182c.svg";